import React from 'react';
import { Empty, Spin } from 'antd';
import './LoadingEmptyComponent.css';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined spin />;

const LoadingEmptyComponent = ({ loading, data }) => {
  if (loading) {
    return <Spin indicator={antIcon} />;
  }

  if (data.length <= 0) {
    return <Empty />;
  }

  return null; // Return null if none of the conditions are met
};

export default LoadingEmptyComponent;
